import React, { Component } from 'react';
import { REARRANGE_COLUMNS } from '../../util/enums/EnumLayers';

/**
 * Using https://github.com/dbushell/Nestable
 */
class ModalRearrangeColumns extends Component {
  static modalType() {
    return REARRANGE_COLUMNS;
  }

  static reducer(modals) {
    return modals.rearrangeColumnsModal;
  }

  static title() {
    return 'Re-order columns';
  }

  static subTitle() {
    return 'Drag and drop a column to move its position';
  }

  componentDidMount() {
    const { userInteraction, columns } = this.props;
    const namesById = {};
    columns.forEach((c) => {
      namesById[c.name().toString()] = c.name();
    });

    $(this._root).nestable({ maxDepth: 1 });
    $(this._root).on('change', () => {
      const orderedIds = $('.dd')
        .nestable('serialize')
        .map((x) => x.id);
      const order = orderedIds.map((id) => namesById[id]);
      userInteraction({ section: 'orderChanged', order })();
    });
  }

  render() {
    const { state, usedAliases } = this.props;

    const listItems = state.initialOrder.map((cn) => {
      let alias = null;
      if (cn.alias()) {
        alias = usedAliases[cn.alias()].name();
      }
      return (
        <li key={cn.toString()} className="dd-item" data-id={cn.toString()}>
          <div className="dd-handle re-column-name-container">
            {cn.name()}
            <span className="pull-right re-table-name">{alias}</span>
          </div>
        </li>
      );
    });

    return (
      <div className="dd" ref={(root) => (this._root = root)}>
        <ol className="dd-list">{listItems}</ol>
      </div>
    );
  }
}

export default ModalRearrangeColumns;
